import { render, staticRenderFns } from "./addNumber.vue?vue&type=template&id=4b70b5ad&scoped=true&"
import script from "./addNumber.vue?vue&type=script&lang=js&"
export * from "./addNumber.vue?vue&type=script&lang=js&"
import style0 from "./addNumber.vue?vue&type=style&index=0&id=4b70b5ad&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b70b5ad",
  null
  
)

export default component.exports